// Regular expression that determines if the input consists of only Arabic numerals
export const integerValidationRegex = /^[0-9]+$/u;

export const integerValidationPattern = integerValidationRegex.source;
